




































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { EEntities } from '@/types'
import { IProjectsOutputMyNotifications } from '@/api/types/response.types'

/* API */
import InternalProjectsAPI from '@/api/modules/internal-projects.api'
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default Vue.extend({
  name: 'EmailNotificationsPicker',

  props: {
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: true,
      showDropdown: false,
      notificationInfo: {} as IProjectsOutputMyNotifications,
      selectedNotificationOptionID: null,
    }
  },

  methods: {
    closeDropdown() {
      this.showDropdown = true
      this.$nextTick(() => {
        this.showDropdown = false
      })
    },
    async onOpen() {
      this.isLoading = true
      if (this.entityType === EEntities.MAILBOXES) {
        this.notificationInfo = await MailboxesAPI.get_MyNotifications(
          this.entityId,
        )
      } else {
        this.notificationInfo = await InternalProjectsAPI.get_MyNotifications(
          this.entityId,
        )
      }
      this.selectedNotificationOptionID = this.notificationInfo.notificationOptionID
      this.isLoading = false
    },
    async updateNotificationOption(id: number) {
      try {
        this.selectedNotificationOptionID = id
        let response
        if (this.entityType === EEntities.MAILBOXES) {
          response = await MailboxesAPI.post_MyNotifications(
            this.entityId,
            this.selectedNotificationOptionID,
          )
        } else {
          response = await InternalProjectsAPI.post_MyNotifications(
            this.entityId,
            this.selectedNotificationOptionID,
          )
        }
        this.$messaging.showSuccess(response.message)
        this.closeDropdown()
      } catch (error) {
        this.$error.emit(error, true)
      }
    },
  },
})
